import Vue from 'vue'
import Router from 'vue-router'

import ListRooms from './views/ListRooms.vue';
import ListZones from './views/ListZones.vue';
import RoomClothes from './views/RoomClothes.vue';
import ZoneClothes from './views/ZoneClothes.vue';
import ZoneRooms from './views/ZoneRooms.vue';
import RoomConsumes from './views/RoomConsumes.vue';
import RoomInspection from './views/RoomInspection.vue';
import Login from './views/Login.vue';

import Error_404 from './views/errors/Error_404.vue';
import NoDistribution from './views/NoDistribution.vue';
import ZoneNoShowReport from './views/ZoneNoShowReport.vue';

Vue.use(Router)

Vue.config.productionTip = false

let default_lang = 'pt';

// localStorage.removeItem('lang');
if(localStorage.getItem('lang') === null) {
  localStorage.setItem('lang', default_lang);
}

const router = new Router({
  mode: process.env.VUE_APP_ROUTER_MODE,
  scrollBehavior (to, from, savedPosition) {
    if (to.params.elem_scroll) {
      document.getElementById(to.params.elem_scroll).scrollIntoView({block: 'center'}); //to.hash as in the documentation didn't work so i used this workarround
    } else if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/',
      meta: {auth: false},
      redirect: '/' +localStorage.lang+ '/login',
    },
    {
      path: '/:lang',
      meta: {auth: false},
      redirect: '/' +localStorage.lang+ '/login',
    },
    {
      path: '/:lang/login',
      meta: {auth: false},
      name: 'login',
      component: Login
    },
    {
      path: '/:lang/list-rooms/:cod_dist_zone',
      meta: {auth: true},
      name: 'list_rooms',
      props: true,
      component: ListRooms
    },
    {
      path: '/:lang/zone-clothes/:cod_dist_zone',
      meta: {auth: true},
      name: 'zone_clothes',
      component: ZoneClothes
    },
    {
      path: '/:lang/zone-rooms/:cod_dist_zone',
      meta: {auth: true},
      name: 'zone_rooms',
      component: ZoneRooms
    },
    {
      path: '/:lang/zone-no-show/:cod_dist_zone',
      meta: {auth: true},
      name: 'zone_no_show',
      component: ZoneNoShowReport
    },
    {
      path: '/:lang/list-zones/',
      meta: {auth: true},
      name: 'list_zones',
      component: ListZones
    },
    {
      path: '/:lang/room-clothes/:cod_dist_zone/:cod_dist_room',
      meta: {auth: true, title: 'Roupa'},
      name: 'room_clothes',
      props: true,
      component: RoomClothes
    },
    {
      path: '/:lang/room-consumes/:cod_dist_zone/:cod_dist_room',
      meta: {auth: true, title: 'Minibar'},
      name: 'room_consumes',
      props: true,
      component: RoomConsumes
    },
    {
      path: '/:lang/room-inspection/:cod_dist_zone/:cod_dist_room',
      meta: {auth: true, title: 'Inspeção'},
      name: 'room_inspection',
      props: true,
      component: RoomInspection
    },
    {
      path: '/:lang/no-distribution',
      meta: {auth: true},
      name: 'no_distribution',
      component: NoDistribution
    },
    {
      path: '*',
      meta: {auth: false},
      name: 'error_404',
      component: Error_404
    }
  ]
})

export default router;